import React, {
  Component
} from 'react';
import './App.css';
import moment from "moment";
import 'moment-timezone';
import 'moment/locale/de';
import 'moment/locale/ar';
import 'moment/locale/fr';
import 'moment/locale/es';
import 'moment/locale/it';
import {
  Button,
  Modal,
  Row,
  Col,
  Image,
  Spinner,
  Badge,
  Alert,
  Form
} from 'react-bootstrap';
import left from './images/left.png';
import right from './images/right.png';
import logo from './images/logo.png';
import poweredByLogo from './images/powered-by-myfitapp.png';
import Util from './Util';
import axios from 'axios';
import I18n from './i18n/I18n';
import { MdAlarmOn, MdLocationOn, MdLocalOffer, MdAccountCircle, MdClose, MdNetworkCell } from "react-icons/md";
import { FaChevronRight, FaChevronLeft } from "react-icons/fa";

class App extends Component {

  constructor(props) {
      super(props);
      this.util = new Util();
      this.i18n = new I18n();
      this.state = {
          return_data: null,
          showModal: false,
          selectedItem:'',

          program:'',
          locations:'',
          categories:'',
          centers:'',
          activityGroups:'',
          locationData: [{id:'', name:''}],
          categoryData: [{id:'', name:''}],
          centerData: [{identifier:'', name:''}],
          activityGroupData: [{identifier:'', name:''}],
          organisationUnitData: [{identifier:'', name:''}],
          mlClassTypeData:[{identifier:'', name:''}],
          selectedLocation: '',
          selectedCategory: '',
          selectedCenter:'',
          selectedActivityGroup:'',
          selectedOrganisationUnit:'',
          selectedMLClassType: '',
          isDataLoaded:false,
          isInitialDataLoaded:false,
          defaultLocation:'',
          defaultCenter:'',
          defaultActivityGroup:'',
          defaultOrganisationUnit:'',
          tmpColCount:0,
          locale:'',
          clubId: '',

          showLocationFilter:true,
          showCategoryFilter:true,
          showCenterFilter:true,
          showActivityGroupFilter:true,
          showOrganisationUnitFilter:true,
          showMLClassTypeFilter:true,
          removeMyFitAppBranding:false,
          enumeratedDays:[]
      };
  }

  componentDidMount() {

      var locale = window.navigator.userLanguage || window.navigator.language;
      let localeArray = ['en','de','fr','ar','es','it']
      if(!localeArray.includes(locale)){
          locale = 'en'
      }
      this.setState({ locale : locale });
      moment.locale(locale);

      window.addEventListener("resize", this.updateDimensions);

      this.addCustomStyle();

      var widgetColumn = this.getCurrentColumnCount();
      var from_day = moment().lang('en').subtract(0, 'days').startOf('day').format('YYYY-MM-DDTHH:mm:ss') + 'Z';
      var to_day = moment().lang('en').add(widgetColumn-1, 'days').endOf('day').format('YYYY-MM-DDTHH:mm:ss') + 'Z';
      this.getEventData(from_day, to_day, this.state.selectedLocation, this.state.selectedCategory, this.state.selectedCenter, this.state.selectedActivityGroup, this.state.selectedOrganisationUnit, this.state.selectedMLClassType);
      this.getFilterData();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }

  componentDidUpdate(){	
    var windowHt = window.document.body.offsetHeight + 250;	
    if(windowHt <= 250){	
      windowHt = 900;	
    }
    window.parent.postMessage(windowHt, "*");	
  }

  addCustomStyle = () => {
    var apiConfig = this.getApiConfig();
    var customCss = 'body { background-color: #fff; }';
    var includeCssUrl = '';
    if(typeof apiConfig.style !== 'undefined'){
      if(typeof apiConfig.style.customCss !== 'undefined'){
        customCss = apiConfig.style.customCss;
      }
      if(typeof apiConfig.style.includeCssUrl !== 'undefined'){
          includeCssUrl = apiConfig.style.includeCssUrl;
      }
    }
    var head = document.head || document.getElementsByTagName('head')[0];

    var style = document.createElement('style');
    head.appendChild(style);
    style.appendChild(document.createTextNode(customCss));

    if(includeCssUrl !== ''){
        var style = document.createElement('style');
        head.appendChild(style);
        style.appendChild(document.createTextNode("@import url('"+includeCssUrl+"')"));
    }
  }

  getApiConfig = (selectedCenter,selectedActivityGroup, selectedOrganisationUnit, selectedMLClassType) => {

    var returnConfig = {};
    var apiKey = this.util.getUrlParameter('apiKey');
    var configData = JSON.parse(atob(this.util.getUrlParameter('config')));
    var filters = configData.data.filters;
    var program = filters.program;
    var locations;
    let externalProviderList = ['EASYSOLUTION', 'XN', 'EXERP', 'MAGICLINE', 'OPENPLAY', 'GLADSTONE', 'INTRATECH', 'BRIGHTLIME', 'LEGEND', 'AIDOO', 'AGILEA', 'MACCENTERCOM', 'CLUBREADY', 'MAGICLINEV2'];
    if(externalProviderList.includes(filters?.provider?.type)) {
        locations = '';
    } else {
        locations = this.state.selectedLocation ?  this.state.selectedLocation  : filters.locations.join(",");
    }
    var categories = filters.categories ? filters.categories.join(",") : '';
    var defaultLocation = configData.data.defaultLocation;
    var defaultCenter = configData.data.defaultCenter;
    var defaultActivityGroup = configData.data.defaultActivityGroup;
    var defaultOrganisationUnit = configData.data.defaultOrganisationUnit;
    var style = configData.data.style;
    /// The enable or disable condition for the filters are supposed to be revisited.
    var showLocationFilter = filters.showLocationFilter === undefined || filters.showLocationFilter === true ?  true  : false;
    var showMLClassTypeFilter =  filters?.mlClassTypeFilter === true ? true : false;
    var showCategoryFilter = filters.showCategoryFilter === undefined || filters.showCategoryFilter === true ?  true  : false;
    var showCenterFilter = filters.showCenterFilter === undefined  || filters.showCenterFilter === false ?  false  : true;
    var showActivityGroupFilter = filters.showActivityGroupFilter === undefined  || filters.showActivityGroupFilter === false ?  false  : true;
    var showOrganisationUnitFilter = filters.showOrgUnitFilter === undefined  || filters.showOrgUnitFilter === false ?  false  : true;
    var removeMyFitAppBranding = filters.removeMyFitAppBranding === undefined || filters.removeMyFitAppBranding === false ?  false  : true;
    var subLocations = filters.subLocations ? filters.subLocations.join(",") : '';
    var provider = filters?.provider?.type ? filters?.provider?.type : 'MFA';
    var centers = filters.centers ? filters.centers.join(",") : '';
    var activityGroups = filters.activityGroupIds ? filters.activityGroupIds.join(",") : '';
    var organisationUnits = filters.organisationUnitIds ? filters.organisationUnitIds.join(",") : '';
    var mlClassTypes = filters.mlClassTypes ? filters.mlClassTypes.join(",") : '';
    var clubId = filters.clubId ? filters.clubId : '';

    if(provider === 'EXERP' && showCenterFilter){
        if(selectedCenter != '' && typeof selectedCenter != 'undefined' && selectedCenter != null){
                filters.centers = [parseInt(selectedCenter)];
        }else if(typeof defaultCenter != 'undefined'){
            filters.centers = [parseInt(defaultCenter)];
        }else {
            defaultCenter = filters.centers[0].toString();
            filters.centers = [filters.centers[0]];
        }
    }

      if(provider === 'EXERP' && showActivityGroupFilter){
          if(selectedActivityGroup != '' && typeof selectedActivityGroup != 'undefined' && selectedActivityGroup != null){
              if(selectedActivityGroup != 'All'){
                  filters.activityGroupIds = [parseInt(selectedActivityGroup)]
              }
          }else if(typeof defaultActivityGroup != 'undefined'){
              filters.activityGroupIds = [parseInt(defaultActivityGroup)]
          }else{
              defaultActivityGroup = 'All';
          }

      }

      if(provider === 'MAGICLINE' && showOrganisationUnitFilter){
          if(selectedOrganisationUnit != '' && typeof selectedOrganisationUnit != 'undefined' && selectedOrganisationUnit != null){
              if(selectedOrganisationUnit != 'All'){
                  filters.organisationUnitIds = [parseInt(selectedOrganisationUnit)]
              }
          }else if(typeof defaultOrganisationUnit != 'undefined'){
              filters.organisationUnitIds = [parseInt(defaultOrganisationUnit)]
          }else{
              defaultOrganisationUnit = 'All';
          }
      }

      if(provider === 'MAGICLINEV2' && showMLClassTypeFilter){
          var effectiveSelectedMLClassType = (typeof selectedMLClassType !== 'undefined' && selectedMLClassType != null) ? selectedMLClassType : this.state.selectedMLClassType;
          if(effectiveSelectedMLClassType !== ''){
              if(effectiveSelectedMLClassType !== 'All'){
                  filters.mlClassTypes = [effectiveSelectedMLClassType]
              }
          }
      }

    var widgetFilter = Object.assign({}, filters);
    if(provider === 'MFA') {
        delete widgetFilter.locations;
        delete widgetFilter.categories;
        delete widgetFilter.subLocations;
    }

    this.setState({ 
      program:program,
      locations:locations,
      categories:categories,
      centers:centers,
      activityGroups:activityGroups,
      defaultLocation:defaultLocation,
      defaultCenter: defaultCenter,
      defaultActivityGroup: defaultActivityGroup,
      defaultOrganisationUnit: defaultOrganisationUnit,
      showLocationFilter:showLocationFilter,
      showMLClassTypeFilter:  showMLClassTypeFilter,
      showCategoryFilter:showCategoryFilter,
      showCenterFilter: showCenterFilter,
      showActivityGroupFilter:showActivityGroupFilter,
      showOrganisationUnitFilter:showOrganisationUnitFilter,
      removeMyFitAppBranding:removeMyFitAppBranding,
      subLocations:subLocations,
        isWidget: true,
        filterString: JSON.stringify(widgetFilter),
        provider: provider,
        clubId:clubId
    });

    returnConfig.apiKey = apiKey;
    returnConfig.provider = provider;
    returnConfig.program = program;
    returnConfig.locations = locations;
    returnConfig.categories = categories;
    returnConfig.centers = centers;
    returnConfig.activityGroups = activityGroups;
    returnConfig.organisationUnits = organisationUnits;
    returnConfig.mlClassTypes = mlClassTypes;
    returnConfig.defaultLocation = defaultLocation;
    returnConfig.style = style;
    returnConfig.subLocations = subLocations;
    returnConfig.isWidget = true;
    returnConfig.filterString = btoa(JSON.stringify(widgetFilter));
    returnConfig.clubId = clubId;
    return returnConfig;
  };

  getEventData(from_day, to_day, selectedLocation, selectedCategory, selectedCenter, selectedActivityGroup, selectedOrganisationUnit, selectedMLClassType) {

    var enumeratedDays = this.util.enumerateDaysBetweenDates(from_day, to_day);
    this.setState({
      from_day:from_day,
      to_day:to_day,
        enumeratedDays:enumeratedDays
    })

      var url = this.util.getEventsApiUrl(this.getApiConfig(selectedCenter, selectedActivityGroup, selectedOrganisationUnit, selectedMLClassType), selectedLocation, selectedCategory, from_day, to_day);
      var current = this;
      axios({
        url:url, headers:{'locale':current.state.locale, 'language': current.state.locale, 'clubid': current.state.clubId}
      })
      .then(function (response) {  current.setState({ isInitialDataLoaded:true, isDataLoaded:true })
          if (response.data.result.length >= 1) { 
              current.setState({
                return_data: current.util.createResponseModal(response.data, from_day, to_day),
              });
          }else if (response.data.result.length == 0){
            current.setState({ return_data:null })
          }
      })
      .catch(function (error) {
        // handle error
        console.log(error);
      })
      .finally(function () {
        // always executed
      });
  }


  handleShow = (selectedItem) => {
    this.setState({
          showModal: true,
          selectedItem:selectedItem
      });
  }

  handleClose = () => {
      this.setState({
          showModal: false
      })
  }

  navigatePrevious = () => {
    this.setState({ isDataLoaded:false })
    let from_day = this.state.from_day
    let widgetColumn = this.getCurrentColumnCount();
    let to_day = moment(from_day, 'YYYY-MM-DDTHH:mm:ssZ', 'en').subtract(1, 'days').endOf('day').format('YYYY-MM-DDTHH:mm:ss') + 'Z';
    from_day = moment(from_day, 'YYYY-MM-DDTHH:mm:ssZ', 'en').subtract(widgetColumn, 'days').startOf('day').format('YYYY-MM-DDTHH:mm:ss') + 'Z';
    
    this.getEventData(from_day, to_day, this.state.selectedLocation, this.state.selectedCategory, this.state.selectedCenter, this.state.selectedActivityGroup, this.state.selectedOrganisationUnit,this.state.selectedMLClassType);
  }

  navigateNext = () => {
    this.setState({ isDataLoaded:false })
    let to_day = this.state.to_day
    let widgetColumn = this.getCurrentColumnCount();
    let from_day = moment(to_day, 'YYYY-MM-DDTHH:mm:ssZ', 'en').subtract(0, 'days').startOf('day').format('YYYY-MM-DDTHH:mm:ss') + 'Z';
    to_day = moment(to_day, 'YYYY-MM-DDTHH:mm:ssZ', 'en').add(widgetColumn-1, 'days').endOf('day').format('YYYY-MM-DDTHH:mm:ss') + 'Z';
    
    this.getEventData(from_day, to_day, this.state.selectedLocation, this.state.selectedCategory, this.state.selectedCenter, this.state.selectedActivityGroup, this.state.selectedOrganisationUnit, this.state.selectedMLClassType);
  }
  getFilterData = () => {
      var provider = this.getApiConfig().provider
      console.log(provider)
      if(provider === 'EXERP'){
          this.getCenterData();
          this.getActivityGroupData();
      }else if(provider === 'MFA') {
          this.getLocationsData();
          this.getCategoryData();
      }else if(provider === 'MAGICLINE'){
          this.getMagicLineLocations();
      }
      else if(provider === 'MAGICLINEV2'){
          this.getMagicLineV2ClassType();
      }

  }

  getLocationsData = () => {
    var url = this.util.getLocationsApiUrl(this.getApiConfig());
    var current = this;
    axios.get(url)
    .then(function (response) {
        if (response.data.length >= 1) {

          var locationStr = current.getApiConfig().locations;
          var locationAry = locationStr.split(",");

          var locationTempAry = [];
          for(var i=0;i<response.data.length;i++){
            if(locationAry.indexOf(response.data[i].id) >= 0){
              locationTempAry.push({"id":response.data[i].id, "name":response.data[i].name});
            }
          }
          current.setState({ locationData : locationTempAry});
        }
    })
    .catch(function (error) {
      // handle error
      console.log(error);
    })
    .finally(function () {
      // always executed
    });
  }
  
  getCategoryData = () => {
    var url = this.util.getCategoriesApiUrl(this.getApiConfig());
    var current = this;
    axios.get(url)
    .then(function (response) {
        if (response.data.length >= 1) {
            var categoryStr = current.getApiConfig().categories;
            var categoryAry = categoryStr.split(",");

            var categoryTempAry = [];
            if(categoryAry.length > 1) {
                categoryTempAry.push({"id":"","name": current.i18n.localizedStrings('all_label')})
            }
            for(var i=0;i<response.data.length;i++){
                if(categoryAry.indexOf(response.data[i].id) >= 0){
                    categoryTempAry.push({"id":response.data[i].id, "name":response.data[i].name});
                }
            }
            current.setState({ categoryData : categoryTempAry});
        }
    })
    .catch(function (error) {
      // handle error
      console.log(error);
    })
    .finally(function () {
      // always executed
    });
  }

    getCenterData = () => {
        var locale = window.navigator.userLanguage || window.navigator.language;
        var url = this.util.getCentersApiUrl(this.getApiConfig(), locale);
        var current = this;
        axios.get(url)
            .then(function (response) {
                if (response.data.length >= 1) {
                    var centerStr = current.getApiConfig().centers;
                    var centerAry = centerStr.split(",");

                    var centerTempAry = [];
                    for(var i=0;i<response.data.length;i++){
                        if(centerAry.indexOf(response.data[i].identifier.toString()) >= 0){
                            centerTempAry.push({"identifier":response.data[i].identifier.toString(), "name":response.data[i].name});
                        }
                    }
                    current.setState({ centerData : current.sortDropDownData(centerTempAry,'name')});
                }
            })
            .catch(function (error) {
                // handle error
                console.log(error);
            })
            .finally(function () {
                // always executed
            });
    }

    getActivityGroupData = () => {
        var locale = window.navigator.userLanguage || window.navigator.language;
        var url = this.util.getActivityGroupApiUrl(this.getApiConfig(), locale);
        var current = this;
        axios.get(url)
            .then(function (response) {
                if (response.data.length >= 1) {
                    var activityGroups = current.getApiConfig().activityGroups;
                    var activityGroupAry = activityGroups.split(",");

                    var activityGroupTempAry = [];
                    activityGroupTempAry.push({"identifier":"All","name": current.i18n.localizedStrings('all_label')});
                    for(var i=0;i<response.data.length;i++){
                        if(activityGroupAry.indexOf(response.data[i].identifier.toString()) >= 0){
                            activityGroupTempAry.push({"identifier":response.data[i].identifier.toString(), "name":response.data[i].name});
                        }
                    }
                    current.setState({ activityGroupData : activityGroupTempAry});
                }
            })
            .catch(function (error) {
                // handle error
                console.log(error);
            })
            .finally(function () {
                // always executed
            });
    }

    getMagicLineLocations = () => {
        console.log('inside getMagicLineLocations')
        var locale = window.navigator.userLanguage || window.navigator.language;
        var url = this.util.getMagiclineLocationsApiUrl(this.getApiConfig(), locale);
        console.log(url)
        var current = this;
        axios.get(url)
            .then(function (response) {
                if (response.data.length >= 1) {
                    var organisationUnits = current.getApiConfig().organisationUnits;
                    var organisationUnitsAry = organisationUnits.split(",");

                    var organisationUnitsTempAry = [];
                    organisationUnitsTempAry.push({"identifier":"All","name": current.i18n.localizedStrings('all_label')});
                    for(var i=0;i<response.data.length;i++){
                        if(organisationUnitsAry.indexOf(response.data[i].identifier.toString()) >= 0){
                            organisationUnitsTempAry.push({"identifier":response.data[i].identifier.toString(), "name":response.data[i].name});
                        }
                    }
                    current.setState({ organisationUnitData : organisationUnitsTempAry });
                }
            })
            .catch(function (error) {
                // handle error
                console.log(error);
            })
            .finally(function () {
                // always executed
            });
    }

    getMagicLineV2ClassType = () => {
        var locale = window.navigator.userLanguage || window.navigator.language;
        var url = this.util.getMagiclineV2ClassTypeApiUrl(this.getApiConfig(), locale);
        var current = this;
        axios.get(url)
            .then(function (response) {
                if (response.data.length >= 1) {
                    var mlClassTypes = current.getApiConfig().mlClassTypes;
                    var mlClassTypesAry = mlClassTypes.split(",");

                    var mlClassTypesTempAry = [];
                    mlClassTypesTempAry.push({"identifier":"All","name": current.i18n.localizedStrings('all_label')});
                    for(var i=0;i<response.data.length;i++){
                        if(mlClassTypesAry.indexOf(response.data[i].identifier.toString()) >= 0){
                            mlClassTypesTempAry.push({"identifier":response.data[i].identifier.toString(), "name":response.data[i].name});
                        }
                    }
                    current.setState({ mlClassTypeData : mlClassTypesTempAry });
                }
            })
            .catch(function (error) {
                // handle error
                console.log(error);
            })
            .finally(function () {
                // always executed
            });
    }

    sortDropDownData = (array, key) =>
    {
        return array.sort(function(a, b)
        {
            var x = a[key]; var y = b[key];
            return ((x < y) ? -1 : ((x > y) ? 1 : 0));
        });
    }

  handleLocationChange = (event) => {
    var widgetColumn = this.getCurrentColumnCount();
    var from_day = moment().subtract(0, 'days').startOf('day').format('YYYY-MM-DDTHH:mm:ss') + 'Z';
    var to_day = moment().add(widgetColumn-1, 'days').endOf('day').format('YYYY-MM-DDTHH:mm:ss') + 'Z';
    this.setState({ selectedLocation : event.target.value, isDataLoaded : false});
    this.getEventData(from_day, to_day, event.target.value, this.state.selectedCategory, null, null, null, null);
  }

  handleCategoryChange = (event) => {
    var widgetColumn = this.getCurrentColumnCount();
    var from_day = moment().subtract(0, 'days').startOf('day').format('YYYY-MM-DDTHH:mm:ss') + 'Z';
    var to_day = moment().add(widgetColumn-1, 'days').endOf('day').format('YYYY-MM-DDTHH:mm:ss') + 'Z';
    this.setState({ selectedCategory : event.target.value, isDataLoaded : false});
    this.getEventData(from_day, to_day, this.state.selectedLocation, event.target.value, null, null, null, null);
  }

  handleCenterChange = (event) => {
        var widgetColumn = this.getCurrentColumnCount();
        var from_day = moment().lang('en').subtract(0, 'days').startOf('day').format('YYYY-MM-DDTHH:mm:ss') + 'Z';
        var to_day = moment().lang('en').add(widgetColumn-1, 'days').endOf('day').format('YYYY-MM-DDTHH:mm:ss') + 'Z';
        this.setState({ selectedCenter : event.target.value, isDataLoaded : false});
        this.getEventData(from_day, to_day, this.state.selectedLocation, this.state.selectedCategory, event.target.value, this.state.selectedActivityGroup, null, null);
  }

  handleActivityGroupChange = (event) => {
      var widgetColumn = this.getCurrentColumnCount();
      var from_day = moment().lang('en').subtract(0, 'days').startOf('day').format('YYYY-MM-DDTHH:mm:ss') + 'Z';
      var to_day = moment().lang('en').add(widgetColumn-1, 'days').endOf('day').format('YYYY-MM-DDTHH:mm:ss') + 'Z';
      this.setState({ selectedActivityGroup : event.target.value, isDataLoaded : false});
      this.getEventData(from_day, to_day, this.state.selectedLocation, this.state.selectedCategory, this.state.selectedCenter, event.target.value, null, null);
  }

    handleMLClassTypeChange = (event) => {
        var widgetColumn = this.getCurrentColumnCount();
        var from_day = moment().lang('en').subtract(0, 'days').startOf('day').format('YYYY-MM-DDTHH:mm:ss') + 'Z';
        var to_day = moment().lang('en').add(widgetColumn-1, 'days').endOf('day').format('YYYY-MM-DDTHH:mm:ss') + 'Z';
        this.setState({ selectedMLClassType : event.target.value, isDataLoaded : false});
        this.getEventData(from_day, to_day, this.state.selectedLocation, this.state.selectedCategory, this.state.selectedCenter, this.state.selectedActivityGroup, this.state.selectedOrganisationUnit, event.target.value);
    }

  handleOrganisationUnitChange = (event) => {
      var widgetColumn = this.getCurrentColumnCount();
      var from_day = moment().lang('en').subtract(0, 'days').startOf('day').format('YYYY-MM-DDTHH:mm:ss') + 'Z';
      var to_day = moment().lang('en').add(widgetColumn-1, 'days').endOf('day').format('YYYY-MM-DDTHH:mm:ss') + 'Z';
      this.setState({ selectedOrganisationUnit : event.target.value, isDataLoaded : false});
      this.getEventData(from_day, to_day, this.state.selectedLocation, this.state.selectedCategory, this.state.selectedCenter, this.state.selectedActivityGroup, event.target.value, this.state.selectedMLClassType);
  }

  getCurrentColumnCount = () => {
    var w = window,
        d = document,
        documentElement = d.documentElement,
        body = d.getElementsByTagName('body')[0],
        width = 0,
        height = 0,
        widthAry = [];

        widthAry.push(w.innerWidth);
        widthAry.push(documentElement.clientWidth);
        widthAry.push(body.clientWidth);
        height = w.innerHeight|| documentElement.clientHeight|| body.clientHeight;
        width = Math.min.apply(Math, widthAry);

        var column = this.util.calculateWidgetColumn(width, height);
        return column;
  }

  updateDimensions = () => {
    var tmpColCount=this.state.tmpColCount;
    var widgetColumn = this.getCurrentColumnCount();

    if(tmpColCount != widgetColumn){
        console.log("updateDimension eventdata");
      this.setState({ tmpColCount : widgetColumn, isDataLoaded : false});
      var from_day = moment().lang('en').subtract(0, 'days').startOf('day').format('YYYY-MM-DDTHH:mm:ss') + 'Z';
      var to_day = moment().lang('en').add(widgetColumn-1, 'days').endOf('day').format('YYYY-MM-DDTHH:mm:ss') + 'Z';
      this.getEventData(from_day, to_day, this.state.selectedLocation, this.state.selectedCategory, this.state.selectedCenter, this.state.selectedActivityGroup, this.state.selectedOrganisationUnit, this.state.selectedMLClassType);
    }
  }

  isSessionAvailable = (a, b) => {
    var c = []	
    Object.keys(a[b]).map((key2, index2) =>  (	
        c.push(a[b][key2].length)	
    ))	
    for(var v=0;v<c.length;v++){	
      if(c[v] != 0){	
        return 'true'
      }
    }
  }

   getLiveStreamBtn = () =>{
        if(this.state.selectedItem != ''){
            if((this.state.selectedItem.video_url !== '') && (!this.state.selectedItem.video_url.endsWith("m3u8"))){
                return <input type="button" className="modal-stream-btn" onClick={ e => this.goToVideoUrl(this.state.selectedItem.video_url)} value={this.state.selectedItem.video_btn_label} />;
            }else if((this.state.selectedItem.video_url !== '') && (this.state.selectedItem.video_url.endsWith("m3u8"))){
                var videoUrl = this.util.getPlayerBaseUrl() + 'player/' + this.state.selectedItem.video_content_id;
                return <input type="button" className="modal-stream-btn" onClick={ e => this.goToVideoUrl(videoUrl)} value={this.state.selectedItem.video_btn_label} />;
            }
        }
   }

    goToVideoUrl(videoUrl) {
        window.open(videoUrl, "_blank");
    }

  render(){
    var jsonData = this.state.return_data;
    var isDataLoaded = this.state.isDataLoaded;
    var isInitialDataLoaded = this.state.isInitialDataLoaded;
    var showLocationFilter = this.state.showLocationFilter;
    var showMLClassTypeFilter = this.state.showMLClassTypeFilter;
    var showCategoryFilter = this.state.showCategoryFilter;
    var showCenterFilter = this.state.showCenterFilter;
    var showActivityGroupFilter = this.state.showActivityGroupFilter;
    var showOrganisationUnitFilter = this.state.showOrganisationUnitFilter;
    var removeMyFitAppBranding = this.state.removeMyFitAppBranding;
    var locale = this.state.locale;
    var selectedMLClassTypeValue = this.state.selectedMLClassType !== '' ? this.state.selectedMLClassType : ((this.state.mlClassTypeData && this.state.mlClassTypeData.length > 0) ? this.state.mlClassTypeData[0].identifier : '');

    // console.log('jsonData', jsonData);
    // console.log('isDataLoaded', isDataLoaded);
    // console.log('isInitialDataLoaded', isInitialDataLoaded);

    if(isInitialDataLoaded == false && jsonData == null){
      return (
        <div className="container" dir={(locale.indexOf('ar') !== -1) ? 'rtl' : 'ltr'}>
            <div className="loading-logo-center">
                {
                    removeMyFitAppBranding === false ?
                        <img src={logo} alt="myFitApp - unique apps for sports facilities" style={{ width:'220px' }}/>
                    :   <h3>{this.i18n.localizedStrings('loading_label')}...</h3>
                }
            </div>
        </div>
      )
    }else if(isInitialDataLoaded == false && jsonData != null){
      return (
        <div className="container" dir={(locale.indexOf('ar') !== -1) ? 'rtl' : 'ltr'}>
            <div className="loading-logo-center">
                {
                    removeMyFitAppBranding === false ?
                        <img src={logo} alt="myFitApp - unique apps for sports facilities" style={{ width:'220px' }}/>
                    :   <h3>{this.i18n.localizedStrings('loading_label')}...</h3>
                }
            </div>
        </div>
      )
    }else if(isInitialDataLoaded == true && jsonData == null){

      return (
        <div className="container" dir={(locale.indexOf('ar') !== -1) ? 'rtl' : 'ltr'}>

          <section className="plan-slider slick-initialized centered" style={{marginTop:'5%',marginBottom:'3%'}}>
          <Row>
              {
                  showLocationFilter === true ?
                      <Col xs={12} xl={6} sm={12} md={6} lg={6} style={{ marginBottom:5}}>
                        <Form.Label>{this.i18n.localizedStrings('location_label')}</Form.Label>
                        <Form.Control as="select" onChange={this.handleLocationChange} >
                          {
                            Object.keys(this.state.locationData).map((key, index) => (
                            <option value={this.state.locationData[key].id} key={this.state.locationData[key].id} selected={this.state.defaultLocation == this.state.locationData[key].id ? 'selected' : ''} >{this.state.locationData[key].name}</option>
                            ))
                          }
                        </Form.Control>
                      </Col>
                  : ''
              }

              {
                  showCategoryFilter === true ?
                      <Col xs={12} xl={6} sm={12} md={6} lg={6} style={{ marginBottom:5}}>
                        <Form.Label>{this.i18n.localizedStrings('category_label')}</Form.Label>
                        <Form.Control as="select" onChange={this.handleCategoryChange} >
                          {
                            Object.keys(this.state.categoryData).map((key, index) => (
                            <option value={this.state.categoryData[key].id} key={this.state.categoryData[key].id} >{this.state.categoryData[key].name}</option>
                            ))
                          }
                        </Form.Control>
                      </Col>
                  : ''
              }

              {
                  showCenterFilter === true ?
                      <Col xs={12} xl={6} sm={12} md={6} lg={6} style= {(locale.indexOf('ar') !== -1) ? {textAlign:"right", marginBottom:5} : {textAlign:"left", marginBottom:5}} >
                          <Form.Label>{this.i18n.localizedStrings('center_label')}</Form.Label>
                          <Form.Control as="select" onChange={this.handleCenterChange} >
                              {
                                  Object.keys(this.state.centerData).map((key, index) => (
                                      <option value={this.state.centerData[key].identifier} key={this.state.centerData[key].identifier} selected={this.state.defaultCenter == this.state.centerData[key].identifier ? 'selected' : ''} >{this.state.centerData[key].name}</option>
                                  ))
                              }
                          </Form.Control>
                      </Col>
                      : ''
              }

              {
                  showActivityGroupFilter === true ?
                      <Col xs={12} xl={6} sm={12} md={6} lg={6} style= {(locale.indexOf('ar') !== -1) ? {textAlign:"right", marginBottom:5} : {textAlign:"left", marginBottom:5}} >
                          <Form.Label>{this.i18n.localizedStrings('activityGroup_label')}</Form.Label>
                          <Form.Control as="select" onChange={this.handleActivityGroupChange} >
                              {
                                  Object.keys(this.state.activityGroupData).map((key, index) => (
                                      <option value={this.state.activityGroupData[key].identifier} key={this.state.activityGroupData[key].identifier} selected={this.state.defaultActivityGroup == this.state.activityGroupData[key].identifier ? 'selected' : ''}>{this.state.activityGroupData[key].name}</option>
                                  ))
                              }
                          </Form.Control>
                      </Col>
                      : ''
              }
              {
                  showOrganisationUnitFilter === true ?
                      <Col xs={12} xl={6} sm={12} md={6} lg={6} style= {(locale.indexOf('ar') !== -1) ? {textAlign:"right", marginBottom:5} : {textAlign:"left", marginBottom:5}} >
                          <Form.Label>{this.i18n.localizedStrings('location_label')}</Form.Label>
                          <Form.Control as="select" onChange={this.handleOrganisationUnitChange} >
                              {
                                  Object.keys(this.state.organisationUnitData).map((key, index) => (
                                      <option value={this.state.organisationUnitData[key].identifier} key={this.state.organisationUnitData[key].identifier} selected={this.state.defaultOrganisationUnit == this.state.organisationUnitData[key].identifier ? 'selected' : ''}>{this.state.organisationUnitData[key].name}</option>
                                  ))
                              }
                          </Form.Control>
                      </Col>
                      : ''
              }
              {
                  showMLClassTypeFilter === true ?
                      <Col xs={12} xl={6} sm={12} md={6} lg={6} style= {(locale.indexOf('ar') !== -1) ? {textAlign:"right", marginBottom:5} : {textAlign:"left", marginBottom:5}} >
                          <Form.Label>{this.i18n.localizedStrings('mlClassType_label')}</Form.Label>
                          <Form.Control as="select" onChange={this.handleMLClassTypeChange} value={selectedMLClassTypeValue || ''} >
                              {
                                  Object.keys(this.state.mlClassTypeData).map((key, index) => (
                                      <option value={this.state.mlClassTypeData[key].identifier} key={this.state.mlClassTypeData[key].identifier} >{this.state.mlClassTypeData[key].name}</option>
                                  ))
                              }
                          </Form.Control>
                      </Col>
                      : ''
              }
            </Row>
          </section>

        <section className="plan-slider slick-initialized centered">

            <Row style={{ visibility: isDataLoaded === false ? 'hidden' : 'visible' }}>
                <Col style= {(locale.indexOf('ar') !== -1) ? {textAlign:"right"} : {textAlign:"left"}}>
                    {
                        locale.indexOf('ar') !== -1 ?
                            <FaChevronRight className="nav-left" onClick={ e => this.navigatePrevious()} />
                            : <FaChevronLeft className="nav-left" onClick={ e => this.navigatePrevious()} />
                    }
                </Col>
                <Col style={(locale.indexOf('ar') !== -1) ? {textAlign:"left"}: {textAlign:"right"}}>
                    {
                        locale.indexOf('ar') !== -1 ?
                            <FaChevronLeft className="nav-right" onClick={ e => this.navigateNext()} />
                            : <FaChevronRight className="nav-right" onClick={ e => this.navigateNext()} />
                    }
                </Col>
            </Row>

            <div aria-live="polite" id="day-header">
                <div className="slick-track" role="listbox" style={{ width:'4000px', transform: `translate3d(0px, 0px, 0px)` }} >
                    {
                        (this.state.enumeratedDays).map((dItem, index) => (
                            <div className="kp-day slick-slide" style={{width: '165px'}} key={'mykey_1_' + index}>
                                <article className="day-card">
                                    <div className="day-weekday">{moment(dItem, 'DD-MM-YYYY').format('dddd')}</div>
                                    <div className="day-date">{moment(dItem, 'DD-MM-YYYY').format('DD MMM YYYY')}</div>
                                </article>
                            </div>
                        ))
                    }
                </div>
            </div>

          <Alert variant="info" style= {(locale.indexOf('ar') !== -1) ? {textAlign:"right"} : {}}>
             <span style={{ fontSize:13 }}>{ this.i18n.localizedStrings('no_record_found_message') } </span>
          </Alert>

          <Row style={{ display: isDataLoaded === true ? 'none' : 'block' }}>
            <Col>
              <Spinner animation="border" variant="secondary" className="loadingIcon"/>
            </Col>
          </Row>

        </section>

            {
                removeMyFitAppBranding === false ?
                    <section className="centered" id="powered-by">
                        <a href="https://www.myfitapp.de/" target="_blank" rel="noopener noreferrer"><img
                            src={poweredByLogo} alt="myFitApp - unique apps for sports facilities"
                            className="powered-by"/></a>
                    </section>
                    : ''
            }

        
      </div>
      )
    }else if(isInitialDataLoaded == true && jsonData != null){
      return (
        <div className="container" dir={(locale.indexOf('ar') !== -1) ? 'rtl' : 'ltr'}>
          <section className="centered" id="filters">

            <Row>

                {
                    showLocationFilter === true ?
                      <Col xs={12} xl={6} sm={12} md={6} lg={6} id="filter-location">
                        <Form.Label className="filter-label">{this.i18n.localizedStrings('location_label')}</Form.Label>
                        <Form.Control as="select" onChange={this.handleLocationChange} >
                          {
                            Object.keys(this.state.locationData).map((key, index) => (
                              <option value={this.state.locationData[key].id} key={this.state.locationData[key].id} selected={this.state.defaultLocation == this.state.locationData[key].id ? 'selected' : ''} >{this.state.locationData[key].name}</option>
                            ))
                          }
                        </Form.Control>
                      </Col>
                    : ''
                }

                {
                    showCategoryFilter === true ?
                        <Col xs={12} xl={6} sm={12} md={6} lg={6} id="filter-category">
                            <Form.Label className="filter-label">{this.i18n.localizedStrings('category_label')}</Form.Label>
                            <Form.Control as="select" onChange={this.handleCategoryChange}>
                                {
                                    Object.keys(this.state.categoryData).map((key, index) => (
                                        <option value={this.state.categoryData[key].id}
                                                key={this.state.categoryData[key].id}>{this.state.categoryData[key].name}</option>
                                    ))
                                }
                            </Form.Control>
                        </Col>
                    : ''
                }

                {
                    showCenterFilter === true ?
                        <Col xs={12} xl={6} sm={12} md={6} lg={6} style= {(locale.indexOf('ar') !== -1) ? {textAlign:"right", marginBottom:5} : {textAlign:"left", marginBottom:5}} >
                            <Form.Label>{this.i18n.localizedStrings('center_label')}</Form.Label>
                            <Form.Control as="select" onChange={this.handleCenterChange} >
                                {
                                    Object.keys(this.state.centerData).map((key, index) => (
                                        <option value={this.state.centerData[key].identifier} key={this.state.centerData[key].identifier} selected={this.state.defaultCenter == this.state.centerData[key].identifier ? 'selected' : ''}>{this.state.centerData[key].name}</option>
                                    ))
                                }
                            </Form.Control>
                        </Col>
                        : ''
                }
                {
                    showMLClassTypeFilter === true ?
                        <Col xs={12} xl={6} sm={12} md={6} lg={6} style= {(locale.indexOf('ar') !== -1) ? {textAlign:"right", marginBottom:5} : {textAlign:"left", marginBottom:5}} >
                            <Form.Label>{this.i18n.localizedStrings('mlClassType_label')}</Form.Label>
                            <Form.Control as="select" onChange={this.handleMLClassTypeChange} value={selectedMLClassTypeValue || ''} >
                                {
                                    Object.keys(this.state.mlClassTypeData).map((key, index) => (
                                        <option value={this.state.mlClassTypeData[key].identifier} key={this.state.mlClassTypeData[key].identifier} >{this.state.mlClassTypeData[key].name}</option>
                                    ))
                                }
                            </Form.Control>
                        </Col>
                        : ''
                }
                {
                    showActivityGroupFilter === true ?
                        <Col xs={12} xl={6} sm={12} md={6} lg={6} style= {(locale.indexOf('ar') !== -1) ? {textAlign:"right", marginBottom:5} : {textAlign:"left", marginBottom:5}} >
                            <Form.Label>{this.i18n.localizedStrings('activityGroup_label')}</Form.Label>
                            <Form.Control as="select" onChange={this.handleActivityGroupChange} >
                                {
                                    Object.keys(this.state.activityGroupData).map((key, index) => (
                                        <option value={this.state.activityGroupData[key].identifier} key={this.state.activityGroupData[key].identifier} selected={this.state.defaultActivityGroup == this.state.activityGroupData[key].identifier ? 'selected' : ''}>{this.state.activityGroupData[key].name}</option>
                                    ))
                                }
                            </Form.Control>
                        </Col>
                        : ''
                }
                {
                    showOrganisationUnitFilter === true ?
                        <Col xs={12} xl={6} sm={12} md={6} lg={6} style= {(locale.indexOf('ar') !== -1) ? {textAlign:"right", marginBottom:5} : {textAlign:"left", marginBottom:5}} >
                            <Form.Label>{this.i18n.localizedStrings('location_label')}</Form.Label>
                            <Form.Control as="select" onChange={this.handleOrganisationUnitChange} >
                                {
                                    Object.keys(this.state.organisationUnitData).map((key, index) => (
                                        <option value={this.state.organisationUnitData[key].identifier} key={this.state.organisationUnitData[key].identifier} selected={this.state.defaultOrganisationUnit == this.state.organisationUnitData[key].identifier ? 'selected' : ''}>{this.state.organisationUnitData[key].name}</option>
                                    ))
                                }
                            </Form.Control>
                        </Col>
                        : ''
                }

            </Row>





            </section>




            <section className="plan-slider slick-initialized centered">

            <Row style={{ visibility: isDataLoaded === false ? 'hidden' : 'visible' }}>
            {
                moment().tz('UTC').isSame(this.state.from_day, 'day') === true && this.state.provider === 'EASYSOLUTION' ? ''
                : <Col style= {(locale.indexOf('ar') !== -1) ? {textAlign:"right"} : {textAlign:"left"}}>
                        {
                            locale.indexOf('ar') !== -1 ?
                                <FaChevronRight className="nav-left" onClick={ e => this.navigatePrevious()} />
                                : <FaChevronLeft className="nav-left" onClick={ e => this.navigatePrevious()} />
                        }
                </Col>
            }
              <Col style={(locale.indexOf('ar') !== -1) ? {textAlign:"left"}: {textAlign:"right"}}>
                  {
                      locale.indexOf('ar') !== -1 ?
                          <FaChevronLeft className="nav-right" onClick={ e => this.navigateNext()} />
                          : <FaChevronRight className="nav-right" onClick={ e => this.navigateNext()} />
                  }

              </Col>
            </Row>



            <div aria-live="polite" id="day-header">
            <div className="slick-track" role="listbox" style={{ width:'4000px', transform: `translate3d(0px, 0px, 0px)` }} >
            {
              Object.keys(jsonData.session_1).map((key, index) => (
                <div className="kp-day slick-slide" style={{width: '165px'}} key={'mykey_1_' + index}>
                  <article className="day-card">
                    <div className="day-weekday">{moment(key, 'DD-MM-YYYY').format('dddd')}</div>
                    <div className="day-date">{moment(key, 'DD-MM-YYYY').format('DD MMM YYYY')}</div>
                  </article>
                </div>
              ))
            }
            </div>
            </div>


            <Row style={{ display: isDataLoaded === true ? 'none' : 'block' }}>
            <Col>
              <Spinner animation="border" variant="secondary" className="loadingIcon"/>
            </Col>
            </Row>
            </section>

            {

            Object.keys(jsonData).map((key2, index2) => (

              this.isSessionAvailable(jsonData, key2) == 'true' ?

              <div key={'mykey_5_'+key2}>
              
              <section className="plan-slider slick-initialized centered">	
              <div aria-live="polite" className="time-section-header">
                <h2 className="time-section-title" style={(locale.indexOf('ar') !== -1) ? {textAlign:"right"} : {}}><b>{ this.i18n.localizedStrings(key2) }</b></h2>
              </div>	
              </section>	

              <section className="plan-slider slick-initialized centered separation" key={'mykey_2_'+key2}>
                <div aria-live="polite" className="slick-list">
                  <div className="slick-track" role="listbox" style={{ width:'4000px', transform: `translate3d(0px, 0px, 0px)` }} >
                    {
                      Object.keys(jsonData[key2]).map((key, index) => (
                        <div className="kp-day slick-slide" style={{width: '165px'}} key={'mykey_3_'+key}>
                          {
                            Object.keys(jsonData[key2][key]).map((key1, index1) => (
                              <article className="event-card" key={'mykey_4_'+key1} style={(locale.indexOf('ar') !== -1) ? {textAlign:"right", borderColor: `${jsonData[key2][key][index1].color}`} : { borderColor: `${jsonData[key2][key][index1].color}`}}
                              onClick={ e=> this.handleShow(jsonData[key2][key][index1])}>
                                <div className="event-name">{ jsonData[key2][key][index1].event_name } </div>
                                <div className="event-time">{ jsonData[key2][key][index1].start_time } - { jsonData[key2][key][index1].end_time }</div>
                                <div className="event-location">
                                    { jsonData[key2][key][index1].location_name }
                                    {
                                        jsonData[key2][key][index1].location_name !== '' && jsonData[key2][key][index1].subLocation_name !== ''
                                            ? ' - ' : ''
                                    }
                                    { jsonData[key2][key][index1].subLocation_name }
                                </div>
                                <div className="event-status">
                                  {
                                      jsonData[key2][key][index1].event_status === 'CANCELLED'
                                      ? <span class="badge event-status-badge-cancelled"> {this.i18n.localizedStrings('cancelled_label')} </span>
                                      :  <span></span>
                                  }

                                  {
                                      jsonData[key2][key][index1].event_status === 'CHANGED'
                                      ?  <span class="badge event-status-badge-changed"> {this.i18n.localizedStrings('changed_label')} </span>
                                      :  <span></span>
                                  }
                                </div>
                              </article>
                            ))
                          }
                        </div>
                      ))
                    }
                  </div>
                </div>
              </section> 
              </div>
              : ''
            
            ))

            }

            {
                removeMyFitAppBranding === false ?
                    <section className="centered" id="powered-by">
                        <a href="https://www.myfitapp.de/" target="_blank" rel="noopener noreferrer"><img
                            src={poweredByLogo} alt="myFitApp - unique apps for sports facilities"
                            className="powered-by"/></a>
                    </section>
                    : ''
            }

            <Modal show={this.state.showModal} onHide={this.handleClose} size="lg" aria-labelledby="contained-modal-title-vcenter" dir={(locale.indexOf('ar') !== -1) ? 'rtl' : 'ltr'} style={(locale.indexOf('ar') !== -1) ? {textAlign:"right"} : {}}>

              <div className={(locale.indexOf('ar') !== -1) ? "modal-close-btn-container-rtl": "modal-close-btn-container"} onClick={this.handleClose}>
                <div className="modal-close-btn">
                  <MdClose className="modal-close-icon"/>
                </div>
              </div>

              <Image className="modal-banner-image" src={this.state.selectedItem.event_type_image} />
              <Modal.Body>
              <div className="modal-container">
                  <div className="modal-event-name">
                    { this.state.selectedItem.event_name }
                        <div className="modal-event-status">
                        {
                            this.state.selectedItem.event_status === 'CANCELLED'
                                ?  <span className="badge event-status-badge-cancelled"> {this.i18n.localizedStrings('cancelled_label')} </span>
                                :  <span></span>
                        }

                        {
                            this.state.selectedItem.event_status === 'CHANGED'
                                ? <span className="badge event-status-badge-changed"> {this.i18n.localizedStrings('changed_label')} </span>
                        :  <span></span>
                        }
                        </div>
                  </div>
                  <div className="modal-event-time"> <MdAlarmOn className="modal-event-time-icon"/> { this.state.selectedItem.start_time} - { this.state.selectedItem.end_time }</div>
                  <div className="modal-event-location"> <MdLocationOn className="modal-event-location-icon"/>
                    { this.state.selectedItem.location_name }
                    {
                        this.state.selectedItem.location_name !== '' && this.state.selectedItem.subLocation_name !== ''
                            ? ' - ' : ''
                    }
                    { this.state.selectedItem.subLocation_name }
                  </div>

                    {
                        this.state.selectedItem.category_name !== ''
                            ? <div className="modal-event-category"> <MdLocalOffer className="modal-event-category-icon" /> { this.state.selectedItem.category_name }</div>
                    : ''
                    }

                  {
                    this.state.selectedItem.trainer_name !== ''
                    ? <div className="modal-event-trainer"> <MdAccountCircle className="modal-event-trainer-icon" /> { this.state.selectedItem.trainer_name }</div>
                    : ''
                  }

                  {
                      this.state.selectedItem.level !== ''
                          ? <div className="modal-event-trainer"> <MdNetworkCell className="modal-event-trainer-icon" /> { this.state.selectedItem.level }</div>
                          : ''
                  }

                  <div className="modal-event-description" dangerouslySetInnerHTML={{__html:this.state.selectedItem.event_type_description}} />

                    {
                        (this.state.selectedItem.event_status === 'CANCELLED') && (this.state.selectedItem.event_status_msg)
                        ?
                        <div className="modal-status-message modal-status-message-cancelled">{ this.state.selectedItem.event_status_msg }</div>
                        :  ''
                    }


                    {
                        (this.state.selectedItem.event_status === 'CHANGED') && (this.state.selectedItem.event_status_msg)
                        ?
                        <div className="modal-status-message modal-status-message-changed">{ this.state.selectedItem.event_status_msg }</div>
                        :  ''
                    }



                  {this.getLiveStreamBtn()}
                  
              </div>
              </Modal.Body>
          </Modal>

        </div>
      )
    }
  
  }
}

export default App;
